<template>
  <v-container fluid class="mt-5 pl-6 pr-6">
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-body-1">Kpi General por Teacher</span>
            <v-spacer></v-spacer>
            <v-btn
              class="mr-2"
              small dark color="green"
              tile
              @click="exportar()"
            >
              <v-icon>mdi-microsoft-excel</v-icon>
            </v-btn>
            <v-btn color="primary" @click="consultar()" small tile>Consultar</v-btn>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6" lg="3" xl="2">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="ciclo"
                  :items="ciclos"
                  label="Selecciona ciclo actual"
                  persistent-hint
                  hide-details
                  return-object
                  item-text="ciclo"
                  item-value="id_ciclo"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="3" xl="2">
                <v-autocomplete
                  filled
                  dense
                  v-model="cicloSup"
                  :items="ciclos"
                  label="Selecciona siguiente ciclo"
                  persistent-hint
                  hide-details
                  return-object
                  item-text="ciclo"
                  item-value="id_ciclo"
                  readonly
                />
              </v-col>
              <v-col cols="12" sm="6" lg="3" xl="2">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="filtroEscuela"
                  :items="opcionesEscuela"
                  label="Escuela"
                  hide-details
                  item-text="text"
                  item-value="value"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="3" xl="2">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="filtroSucursal"
                  :items="plantelesFiltro"
                  label="Sucursal"
                  hide-details
                  item-text="plantel"
                  item-value="id_plantel"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="3" xl="2">
                <v-text-field
                  v-model="search"
                  filled
                  dense
                  hide-details
                  clearable
                  label="Buscar teacher"
                />
              </v-col>
            </v-row>

            <v-card outlined class="pa-3 mt-4">
              <div class="subtitle-2 grey--text text--darken-1 mb-1">
                Resumen RI (vista filtrada · misma regla KPI General)
              </div>
              <v-row dense align="center">
                <v-col cols="6" sm="3"><strong>Reinscribibles</strong><br />{{ filaTotal.reinscribibles }}</v-col>
                <v-col cols="6" sm="3"><strong>Acumulado</strong><br />{{ filaTotal.totalAlumnosSiguientes }}</v-col>
                <v-col cols="6" sm="3"><strong>Faltantes</strong><br />{{ filaTotal.faltantes }}</v-col>
                <v-col cols="6" sm="3"><strong>% RI</strong><br />{{ filaTotal.porcentajeAvance }}%</v-col>
              </v-row>
              <div class="caption grey--text mt-2">
                Pos. RI: mejor % RI = #1. Pos. carga: más grupos del rol = #1 (misma regla que Carga laboral).
                Diferencia = Pos. RI − Pos. carga (positivo = más carga que RI).
              </div>
            </v-card>

            <v-data-table
              :headers="headers2"
              :items="teachersTabla"
              :search="search"
              item-key="id_maestro"
              sort-by="faltantes"
              sort-desc
              class="elevation-0 mt-4"
              dense
              mobile-breakpoint="200"
              id="kpiTeacher"
              :footer-props="{ itemsPerPageOptions: [10, 25, 50], showFirstLastPage: true }"
            >
              <template v-slot:item.irregulares="{ item }">
                <v-chip color="red" dark small @click="verIrregulares( item.alumnosIrregualres )" v-if="item.irregulares > 0 ">{{ item.irregulares }}</v-chip>
                <v-chip color="green" dark small v-else>{{ item.irregulares }}</v-chip>
              </template>

              <template v-slot:item.becados="{ item }">
                <v-chip color="red" dark small @click="verBecados( item.alumnosBecados )" v-if="item.becados > 0 ">{{ item.becados }}</v-chip>
                <v-chip color="green" dark small v-else>{{ item.becados }}</v-chip>
              </template>

              <template v-slot:item.reinscribibles="{ item }">
                <v-chip small @click="verAlumnos( item.alumnosReincribibles )">{{ item.reinscribibles }}</v-chip>
              </template>

              <template v-slot:item.totalAlumnosSiguientes="{ item }">
                <v-chip small @click="verAlumnos( item.alumnosAcumulados )">{{ item.totalAlumnosSiguientes }}</v-chip>
              </template>

              <template v-slot:item.faltantes="{ item }">
                <v-chip small @click="verAlumnos( item.alumnosFaltantes )">{{ item.faltantes }}</v-chip>
              </template>

              <template v-slot:item.posicion_ri="{ item }">
                <strong>#{{ item.posicion_ri }}</strong>
              </template>

              <template v-slot:item.posicion_carga="{ item }">
                <strong>#{{ item.posicion_carga }}</strong>
              </template>

              <template v-slot:item.diferencia_posicion="{ item }">
                <v-chip
                  x-small
                  dark
                  :color="colorDiferencia(item.diferencia_posicion)"
                >{{ textoDiferencia(item.diferencia_posicion) }}</v-chip>
              </template>

              <template v-slot:item.meta_alumnos="{ item }">
                <v-chip
                  small
                  :color="item.totalAlumnosSiguientes >= item.meta_alumnos ? 'green' : 'red'"
                  dark
                  @click="datosMeta = item, dialogMeta = true"
                >META</v-chip>
              </template>

              <template v-slot:body.append>
                <tr class="font-weight-bold grey lighten-3">
                  <td></td>
                  <td>TOTAL</td>
                  <td></td>
                  <td>{{ filaTotal.totalAlumnosActuales }}</td>
                  <td>
                    <v-chip :color="filaTotal.irregulares > 0 ? 'red' : 'green'" dark small>{{ filaTotal.irregulares }}</v-chip>
                  </td>
                  <td>
                    <v-chip :color="filaTotal.becados > 0 ? 'red' : 'green'" dark small>{{ filaTotal.becados }}</v-chip>
                  </td>
                  <td>{{ filaTotal.becadoCertificacion }}</td>
                  <td>{{ filaTotal.certificacion }}</td>
                  <td>
                    <v-chip small>{{ filaTotal.reinscribibles }}</v-chip>
                  </td>
                  <td>
                    <v-chip small>{{ filaTotal.totalAlumnosSiguientes }}</v-chip>
                  </td>
                  <td>{{ filaTotal.totalAlumnosAyer }}</td>
                  <td>
                    <v-chip small>{{ filaTotal.faltantes }}</v-chip>
                  </td>
                  <td>{{ filaTotal.porcentajeAvance }}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    <v-chip
                      small
                      :color="filaTotal.totalAlumnosSiguientes >= filaTotal.meta_alumnos ? 'green' : 'red'"
                      dark
                    >META</v-chip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialogIrregulares"
      persistent
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5">
          Alumnos irregulares
        </v-card-title>
        <v-card-text>
          <div>Alumno con adeudo, no está en certificación y tampoco es alumno becado</div>
          <v-data-table
            :headers="headersIrregulares"
            :items="alumnos"
            class="elevation-0 mt-4"
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            rounded
            dark
            small
            @click="dialogIrregulares = false, alumnos = []"
          >
            Listo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogBecados"
      persistent
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5">
          Alumnos Becados
        </v-card-title>
        <v-card-text>
          <div>Alumnos que no pagaron nada :p</div>
          <v-data-table
            :headers="headersIrregulares"
            :items="alumnos"
            class="elevation-0 mt-4"
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            rounded
            dark
            small
            @click="dialogBecados = false, alumnos = []"
          >
            Listo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogAlumnos"
      persistent
      max-width="900"
    >
      <v-card>
        <v-card-title class="text-h5">
          Alumnos
          <v-spacer></v-spacer>
          <v-btn
            class="mr-2"
            small dark color="green"
            @click="exportExcelData( alumnos, 'reinscribibles')">
            <v-icon>mdi-microsoft-excel</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headersAlumnos"
            :items="alumnos"
            class="elevation-0 mt-4"
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            rounded
            dark
            small
            @click="dialogAlumnos = false, alumnos = []"
          >
            Listo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="datosMeta"
      v-model="dialogMeta"
      max-width="300"
    >
      <v-card>
        <v-card-title class="text-h5">
          META
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-list class="transparent">
            <v-list-item>
              <v-list-item-title>Semana 2:</v-list-item-title>
              <v-list-item-subtitle class="text-right black--text">
                <v-chip small color="green" dark>{{ Math.ceil((datosMeta.reinscribibles * .80 )) }}</v-chip>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Semana 5:</v-list-item-title>
              <v-list-item-subtitle class="text-right black--text">
                <v-chip small color="green" dark>{{ Math.ceil((datosMeta.reinscribibles * .93 )) }}</v-chip>
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
          <div class="text-center black--text text-subtitle-1"> REINSCRIBIBLES: {{ datosMeta.reinscribibles }} </div>
          <div class="text-center black--text text-subtitle-1"> META ACTUAL: {{ datosMeta.meta_alumnos }} </div>
          <div class="text-center black--text text-subtitle-1"> LLEVAS: {{ datosMeta.totalAlumnosSiguientes }} </div>
          <div class="text-center black--text text-subtitle-1"> FALTAN: {{ datosMeta.meta_alumnos - datosMeta.totalAlumnosSiguientes }} </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            tile
            dark
            small
            @click="dialogMeta = false"
          >
            Listo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros"/>
    <carga v-if="cargar"/>

  </v-container>
</template>
<script>
import axios from 'axios';
  import XLSX from 'xlsx'
  import Alerta          from '@/components/alertas/Alerta.vue'
  import carga           from '@/components/alertas/carga.vue';

  import validarErrores  from '@/mixins/validarErrores'
  import { mapaCargaUnicos, semanaDelCiclo } from '@/utils/cargaLaboralRol'

  const COORDINADORES = [
    { idteacher: 886, nombre: 'XCARET CORONA SALINAS', planteles: [14,12,16,9] },
    { idteacher: 1593, nombre: 'MOISES LARA PEREZ', planteles: [2,3,4,6,7,8,10,11,21,32] },
    { idteacher: 1177, nombre: 'CARLOS EDUARDO DE LEON HERNANDEZ', planteles: [17,29,10004,1,5,22,24,23,14,12,9,16] },
    { idteacher: 1336, nombre: 'JESUS OSWALDO MONTALVO LUNA', planteles: [5,2,3] },
    { idteacher: 1552, nombre: 'Saul Dario Guzman Ortiz', planteles: [31,28,27,25] },
  ]

  export default {
    components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores ],

    data: () => ({
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,
      search: '',
      filtroEscuela: null,
      filtroSucursal: null,
      plantelesLista: [],
      opcionesEscuela: [
        { text: 'INBI', value: 1 },
        { text: 'FAST', value: 2 },
      ],

      headers2: [
        { text: 'id'               , value: 'id_maestro'                   },
        { text: 'Teacher'          , value: 'nombre_completo'              },
        { text: 'Planteles'        , value: 'plantelesTexto'               },
        { text: 'A. Ciclo Actual'  , value: 'totalAlumnosActuales'         },
        { text: 'A. Irregulares'   , value: 'irregulares'                  },
        { text: 'Becados'          , value: 'becados'                      },
        { text: 'B. Certificacion' , value: 'becadoCertificacion'          },
        { text: 'Certificacion'    , value: 'certificacion'                },
        { text: 'Reinscribibles'   , value: 'reinscribibles'               },
        { text: 'Acumulado'        , value: 'totalAlumnosSiguientes'       },
        { text: 'Avance'           , value: 'totalAlumnosAyer'             },
        { text: 'Faltantes'        , value: 'faltantes', class: 'columna2' },
        { text: '%RI'              , value: 'porcentajeAvance'             },
        { text: 'Pos. RI'          , value: 'posicion_ri'                  },
        { text: 'Pos. carga'       , value: 'posicion_carga'               },
        { text: 'Diferencia'       , value: 'diferencia_posicion'          },
        { text: 'META'             , value: 'meta_alumnos'                 },
      ],

      headersIrregulares: [
        { text: 'id_alumno'        , value: 'id_alumno' },
        { text: 'Nombre'           , value: 'nombre' },
        { text: 'id_maestro'       , value: 'id_maestro' },
        { text: 'id_maestro_2'     , value: 'id_maestro_2' },
        { text: 'Adeudo'           , value: 'adeudo' },
        { text: 'Pagado'           , value: 'pagado' },
      ],

      headersAlumnos: [
        { text: 'id_alumno'  , value: 'id_alumno'  },
        { text: 'Nombre'     , value: 'nombre'     },
        { text: 'Grupo'      , value: 'grupo'      },
      ],

      ciclos:[],
      ciclo:null,
      cicloSup:null,
      cicloInf: null,
      resultado:[],
      alumnos:[],
      dialogIrregulares: false,
      dialogBecados:false,
      dialogAlumnos:false,
      datosMeta: null,
      dialogMeta: false,
      gruposRoles: [],
    }),

    watch: {
      ciclo () {
        if(this.ciclo){
          const positionCiclo = this.ciclos.indexOf(this.ciclo)

          if(positionCiclo == 0 ){
            return this.validarErrorDirecto('El ciclo anterior esta cerrado, favor de abrir el ciclo anterior')
          }

          this.cicloSup = this.ciclos[ positionCiclo + 1 ]
          this.cicloInf = this.ciclos[ positionCiclo - 1 ]
          this.consultar()
        }
      },
      filtroEscuela () {
        if (this.filtroSucursal && this.plantelesFiltro) {
          let existe = false
          for (let i = 0; i < this.plantelesFiltro.length; i++) {
            if (Number(this.plantelesFiltro[i].id_plantel) === Number(this.filtroSucursal)) {
              existe = true
            }
          }
          if (!existe) this.filtroSucursal = null
        }
      },
    },

    computed:{
      porcentajeAplicar () {
        if (!this.ciclo || !this.ciclo.fecha_inicio_ciclo) return 0.80
        const partes = String(this.ciclo.fecha_inicio_ciclo).substring(0, 10).split('-')
        if (partes.length !== 3) return 0.80
        const inicio = new Date(Number(partes[0]), Number(partes[1]) - 1, Number(partes[2]))
        const corte = new Date(inicio.getTime())
        corte.setDate(corte.getDate() + 14)
        return new Date() >= corte ? 0.93 : 0.80
      },

      plantelesFiltro () {
        let lista = this.plantelesLista || []
        if (this.filtroEscuela) {
          const esc = Number(this.filtroEscuela)
          lista = lista.filter(function (p) { return Number(p.escuela) === esc })
        }
        return lista
      },

      mapaPlanteles () {
        const mapa = {}
        const lista = this.plantelesLista || []
        for (let i = 0; i < lista.length; i++) {
          mapa[lista[i].id_plantel] = lista[i]
        }
        return mapa
      },

      hayFiltroVista () {
        return !!(this.filtroEscuela || this.filtroSucursal)
      },

      teachersBase () {
        const lista = this.resultado || []
        const out = []
        for (let i = 0; i < lista.length; i++) {
          const t = lista[i]
          if (!t) continue
          if (Number(t.id_maestro) === 100000) continue
          if (t.nombre_completo === 'TOTAL') continue
          out.push(t)
        }
        return out
      },

      teachersTabla () {
        const self = this
        const filtrados = this.teachersBase.filter(function (t) {
          return self.teacherPasaFiltro(t)
        })
        const hayFiltro = this.hayFiltroVista
        const rows = []
        for (let i = 0; i < filtrados.length; i++) {
          rows.push(hayFiltro ? this.recalcularTeacher(filtrados[i]) : this.enriquecerTeacher(filtrados[i]))
        }
        const visibles = rows.filter(function (t) {
          if (!hayFiltro) return true
          return Number(t.totalAlumnosActuales) > 0 || Number(t.reinscribibles) > 0
        })
        return this.aplicarPosiciones(visibles)
      },

      filaTotal () {
        return this.armarTotal(this.teachersTabla)
      },
    },

    async created () {
      this.cargar = true
      await this.getCiclosActivos()
      await this.cargarPlanteles()
      this.cargar = false
    },

    methods: {
      escuelaDePlantelNombre (nombre) {
        const texto = String(nombre || '').toUpperCase()
        return texto.indexOf('FAST') > -1 ? 2 : 1
      },

      cargarPlanteles () {
        return this.$http.get('kpi.planteles.all').then(response => {
          const raw = response.data || []
          const lista = []
          for (let i = 0; i < raw.length; i++) {
            const p = raw[i]
            lista.push({
              id_plantel: p.id_plantel,
              plantel: p.plantel,
              escuela: p.escuela ? Number(p.escuela) : this.escuelaDePlantelNombre(p.plantel),
            })
          }
          lista.sort(function (a, b) {
            return String(a.plantel).localeCompare(String(b.plantel))
          })
          this.plantelesLista = lista
        }).catch(error => {
          this.validarError(error.response.data.message)
        })
      },

      getCiclosActivos( ){
        return this.$http.get('kpi.ciclos.all').then(response=>{
          this.ciclos = response.data
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      async consultar () {
        this.resultado = []
        this.gruposRoles = []
        this.cargar = true
        try {
          await Promise.all([
            this.riFast(true),
            this.cargarCargaLaboral(),
          ])
        } finally {
          this.cargar = false
        }
      },

      teacherPasaFiltro (teacher) {
        const ids = teacher.idPlanteles || []
        if (this.filtroSucursal) {
          const suc = Number(this.filtroSucursal)
          let ok = false
          for (let i = 0; i < ids.length; i++) {
            if (Number(ids[i]) === suc) ok = true
          }
          if (!ok) return false
        }
        if (this.filtroEscuela) {
          const escuelas = this.escuelasDeTeacher(teacher)
          let okEsc = false
          for (let j = 0; j < escuelas.length; j++) {
            if (Number(escuelas[j]) === Number(this.filtroEscuela)) okEsc = true
          }
          if (!okEsc) return false
        }
        return true
      },

      escuelasDeTeacher (teacher) {
        const result = []
        const ids = teacher.idPlanteles || []
        for (let i = 0; i < ids.length; i++) {
          const p = this.mapaPlanteles[ids[i]]
          if (p && result.indexOf(Number(p.escuela)) === -1) {
            result.push(Number(p.escuela))
          }
        }
        const alumnos = teacher.alumnosPlantel || []
        for (let j = 0; j < alumnos.length; j++) {
          let esc = Number(alumnos[j].escuela)
          if (!esc) esc = this.escuelaDePlantelNombre(alumnos[j].plantel)
          if (esc && result.indexOf(esc) === -1) result.push(esc)
        }
        return result
      },

      alumnoPasaFiltro (alumno) {
        if (!alumno) return false
        if (this.filtroSucursal && Number(alumno.id_plantel) !== Number(this.filtroSucursal)) return false
        if (this.filtroEscuela) {
          let esc = Number(alumno.escuela)
          if (!esc) esc = this.escuelaDePlantelNombre(alumno.plantel)
          if (esc && esc !== Number(this.filtroEscuela)) return false
        }
        return true
      },

      filtrarLista (lista) {
        if (!Array.isArray(lista)) return []
        if (!this.hayFiltroVista) return lista
        const self = this
        return lista.filter(function (el) { return self.alumnoPasaFiltro(el) })
      },

      textoLista (valor) {
        if (Array.isArray(valor)) return valor.join(', ')
        if (valor == null) return ''
        return String(valor)
      },

      metaDeReinscribibles (reinscribibles, metaBackend) {
        if (metaBackend != null && metaBackend !== '' && !this.hayFiltroVista) {
          return Number(metaBackend)
        }
        return Math.ceil(Number(reinscribibles || 0) * this.porcentajeAplicar)
      },

      enriquecerTeacher (teacher) {
        const meta = this.metaDeReinscribibles(teacher.reinscribibles, teacher.meta_alumnos)
        return Object.assign({}, teacher, {
          plantelesTexto: this.textoLista(teacher.planteles),
          teachersTexto: this.textoLista(teacher.teachers),
          meta_alumnos: meta,
          porcentajeAvance: teacher.porcentajeAvance != null ? teacher.porcentajeAvance : 0,
        })
      },

      recalcularTeacher (teacher) {
        const plantel = this.filtrarLista(teacher.alumnosPlantel)
        const reins = this.filtrarLista(teacher.alumnosReincribibles)
        const acum = this.filtrarLista(teacher.alumnosAcumulados)
        const falt = this.filtrarLista(teacher.alumnosFaltantes)
        const irreg = this.filtrarLista(teacher.alumnosIrregualres)
        const beca = this.filtrarLista(teacher.alumnosBecados)
        const certi = this.filtrarLista(teacher.alumnosCertificacion)
        const becaCerti = this.filtrarLista(teacher.alumnosBecaCertificacion)
        const sig = this.filtrarLista(teacher.alumnosSiguientes)

        const reinscribibles = reins.length
        const totalAlumnosSiguientes = sig.length
        const faltantes = reinscribibles - totalAlumnosSiguientes
        const porcentajeAvance = reinscribibles > 0
          ? ((totalAlumnosSiguientes / reinscribibles) * 100).toFixed(2)
          : 0

        let avanceAyer = 0
        for (let i = 0; i < sig.length; i++) {
          if (sig[i].fecha_alta_nuevo_grupo) avanceAyer += 1
        }

        const plantelesNombres = []
        const ids = []
        for (let j = 0; j < plantel.length; j++) {
          if (plantel[j].plantel && plantelesNombres.indexOf(plantel[j].plantel) === -1) {
            plantelesNombres.push(plantel[j].plantel)
          }
          if (plantel[j].id_plantel && ids.indexOf(plantel[j].id_plantel) === -1) {
            ids.push(plantel[j].id_plantel)
          }
        }

        return Object.assign({}, teacher, {
          planteles: plantelesNombres.length ? plantelesNombres : teacher.planteles,
          plantelesTexto: this.textoLista(plantelesNombres.length ? plantelesNombres : teacher.planteles),
          teachersTexto: this.textoLista(teacher.teachers),
          idPlanteles: ids.length ? ids : teacher.idPlanteles,
          totalAlumnosActuales: plantel.length,
          irregulares: irreg.length,
          alumnosIrregualres: irreg,
          becados: beca.length,
          alumnosBecados: beca,
          becadoCertificacion: becaCerti.length,
          certificacion: certi.length,
          reinscribibles: reinscribibles,
          alumnosReincribibles: reins,
          totalAlumnosSiguientes: totalAlumnosSiguientes,
          alumnosAcumulados: acum,
          totalAlumnosAyer: avanceAyer,
          faltantes: faltantes,
          alumnosFaltantes: falt,
          porcentajeAvance: porcentajeAvance,
          meta_alumnos: Math.ceil(reinscribibles * this.porcentajeAplicar),
        })
      },

      armarTotal (rows) {
        const vacio = {
          nombre_completo: 'TOTAL',
          totalAlumnosActuales: 0,
          irregulares: 0,
          becados: 0,
          becadoCertificacion: 0,
          certificacion: 0,
          reinscribibles: 0,
          totalAlumnosSiguientes: 0,
          totalAlumnosAyer: 0,
          faltantes: 0,
          porcentajeAvance: 0,
          meta_alumnos: 0,
        }
        if (!rows || !rows.length) return vacio
        const t = Object.assign({}, vacio)
        for (let i = 0; i < rows.length; i++) {
          const r = rows[i]
          t.totalAlumnosActuales += Number(r.totalAlumnosActuales) || 0
          t.irregulares += Number(r.irregulares) || 0
          t.becados += Number(r.becados) || 0
          t.becadoCertificacion += Number(r.becadoCertificacion) || 0
          t.certificacion += Number(r.certificacion) || 0
          t.reinscribibles += Number(r.reinscribibles) || 0
          t.totalAlumnosSiguientes += Number(r.totalAlumnosSiguientes) || 0
          t.totalAlumnosAyer += Number(r.totalAlumnosAyer) || 0
          t.faltantes += Number(r.faltantes) || 0
          t.meta_alumnos += Number(r.meta_alumnos) || 0
        }
        t.porcentajeAvance = t.reinscribibles > 0
          ? ((t.totalAlumnosSiguientes / t.reinscribibles) * 100).toFixed(2)
          : 0
        return t
      },

      riFast (silencioso) {
        if (!silencioso) this.cargar = true
        const payload = {
          cicloPre:  this.cicloInf,
          cicloAct: this.ciclo,
          cicloSig:  this.cicloSup
        }
        return this.$http.post('kpi.cantactual.teachers', payload ).then(response=>{

          this.resultado = response.data.riTeachers || []

          for( const i in this.resultado ){

            const { idPlanteles } = this.resultado[i]

            let teachersLider = []

            if( idPlanteles ){

              for( const j in COORDINADORES ){

                const { planteles, nombre } = COORDINADORES[j]

                if( idPlanteles.some(plantel => planteles.includes(plantel) ) ){

                  teachersLider.push(nombre)

                }

              }

            }

            this.resultado[i]['teachers'] = teachersLider

          }



        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { if (!silencioso) this.cargar = false })
      },

      verIrregulares( alumnos ){
        this.alumnos = alumnos || []
        this.dialogIrregulares = true
      },

      verBecados( alumnos ){
        this.alumnos = alumnos || []
        this.dialogBecados = true
      },

      verAlumnos( alumnos ){
        this.alumnos       = alumnos || []
        this.dialogAlumnos = true
      },

      cargarCargaLaboral () {
        this.gruposRoles = []
        if (!this.ciclo || !this.ciclo.id_ciclo) return Promise.resolve()
        return this.$http.post('rol.clases', this.ciclo).then(response => {
          const data = response.data || {}
          this.gruposRoles = data.respuesta || []
        }).catch(error => {
          this.gruposRoles = []
          let msg = 'No se pudo cargar la carga laboral del rol'
          if (error && error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message
          }
          this.validarError(msg)
        })
      },

      aplicarPosiciones (rows) {
        const lista = rows || []
        const fechaInicio = this.ciclo && this.ciclo.fecha_inicio_ciclo ? this.ciclo.fecha_inicio_ciclo : ''
        const semana = semanaDelCiclo(fechaInicio)
        const filtros = {}
        if (this.filtroEscuela) filtros.id_unidad_negocio = this.filtroEscuela
        if (this.filtroSucursal) filtros.id_plantel = this.filtroSucursal
        const mapaCarga = mapaCargaUnicos(this.gruposRoles, semana, filtros)

        const conCarga = []
        for (let i = 0; i < lista.length; i++) {
          const t = lista[i]
          const carga = mapaCarga[Number(t.id_maestro)]
          conCarga.push(Object.assign({}, t, {
            cantidad_grupos: carga ? carga.cantidad_grupos : 0,
            horas_carga: carga ? carga.horas_totales : 0,
          }))
        }

        const porRi = conCarga.slice()
        porRi.sort(function (a, b) {
          const pa = Number(a.porcentajeAvance) || 0
          const pb = Number(b.porcentajeAvance) || 0
          if (pb !== pa) return pb - pa
          return (Number(b.reinscribibles) || 0) - (Number(a.reinscribibles) || 0)
        })
        const posRi = {}
        for (let r = 0; r < porRi.length; r++) {
          posRi[porRi[r].id_maestro] = r + 1
        }

        const porCarga = conCarga.slice()
        porCarga.sort(function (a, b) {
          if (b.cantidad_grupos !== a.cantidad_grupos) return b.cantidad_grupos - a.cantidad_grupos
          if (b.horas_carga !== a.horas_carga) return b.horas_carga - a.horas_carga
          const na = a.nombre_completo || ''
          const nb = b.nombre_completo || ''
          if (na !== nb) return na < nb ? -1 : 1
          return 0
        })
        const posCarga = {}
        for (let c = 0; c < porCarga.length; c++) {
          posCarga[porCarga[c].id_maestro] = c + 1
        }

        const out = []
        for (let j = 0; j < conCarga.length; j++) {
          const t = conCarga[j]
          const pri = posRi[t.id_maestro]
          const pca = posCarga[t.id_maestro]
          out.push(Object.assign({}, t, {
            posicion_ri: pri,
            posicion_carga: pca,
            diferencia_posicion: pri - pca,
          }))
        }
        return out
      },

      colorDiferencia (valor) {
        const n = Number(valor) || 0
        if (n > 0) return 'red'
        if (n < 0) return 'green'
        return 'grey'
      },

      textoDiferencia (valor) {
        const n = Number(valor) || 0
        if (n > 0) return '+' + n
        return String(n)
      },

      exportar(){
        this.exportExcel()
      },

      s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
      },

      filasExport () {
        const rows = []
        const lista = this.teachersTabla || []
        for (let i = 0; i < lista.length; i++) {
          const r = lista[i]
          rows.push({
            id: r.id_maestro,
            teacher: r.nombre_completo,
            planteles: r.plantelesTexto,
            ciclo_actual: r.totalAlumnosActuales,
            irregulares: r.irregulares,
            becados: r.becados,
            b_certificacion: r.becadoCertificacion,
            certificacion: r.certificacion,
            reinscribibles: r.reinscribibles,
            acumulado: r.totalAlumnosSiguientes,
            avance: r.totalAlumnosAyer,
            faltantes: r.faltantes,
            porcentaje_ri: r.porcentajeAvance,
            posicion_ri: r.posicion_ri,
            posicion_carga: r.posicion_carga,
            diferencia: r.diferencia_posicion,
            meta: r.meta_alumnos,
          })
        }
        const t = this.filaTotal
        rows.push({
          id: '',
          teacher: 'TOTAL',
          planteles: '',
          ciclo_actual: t.totalAlumnosActuales,
          irregulares: t.irregulares,
          becados: t.becados,
          b_certificacion: t.becadoCertificacion,
          certificacion: t.certificacion,
          reinscribibles: t.reinscribibles,
          acumulado: t.totalAlumnosSiguientes,
          avance: t.totalAlumnosAyer,
          faltantes: t.faltantes,
          porcentaje_ri: t.porcentajeAvance,
          posicion_ri: '',
          posicion_carga: '',
          diferencia: '',
          meta: t.meta_alumnos,
        })
        return rows
      },

      exportExcel(){
        let dataAnt = XLSX.utils.json_to_sheet(this.filasExport())

        const workbook = XLSX.utils.book_new()
        const filename = 'KPI_TEACHERS'
        XLSX.utils.book_append_sheet(workbook, dataAnt, 'RI TEACHERS')

        var wbout = XLSX.write(workbook, {
          bookType: 'xls',
          bookSST: false,
          type: 'binary'
        });

        const file = new File([new Blob([this.s2ab(wbout)])], filename + '.xls')

        let formData = new FormData();
        formData.append('file',file);

        this.$http.post('pdfs',formData).then(response=> {
          window.location = axios.defaults.baseURL + 'pdfs/' + filename + '.xls'
        }).catch(error=> {
          alert(error.body)
          console.log(error);
        });
      },

      exportExcelData( alumnos, nameExcel ){
        let data = XLSX.utils.json_to_sheet(alumnos || [])

        const workbook = XLSX.utils.book_new()
        const filename = nameExcel
        XLSX.utils.book_append_sheet(workbook, data, filename)

        var wbout = XLSX.write(workbook, {
          bookType: 'xls',
          bookSST: false,
          type: 'binary'
        });

        const file = new File([new Blob([this.s2ab(wbout)])], filename + '.xls')

        let formData = new FormData();
        formData.append('file',file);

        this.$http.post('pdfs',formData).then(response=> {
          window.location = axios.defaults.baseURL + 'pdfs/' + filename + '.xls'
        }).catch(error=> {
          alert(error.body)
          console.log(error);
        });
      },


    },
  }
</script>
<style>

  #kpiTeacher td:nth-child(10) {
    background-color: #E8E8E8 !important;
  }

  #kpiTeacher td:nth-child(11) {
    background-color: #E8E8E8 !important;
  }

  #kpiTeacher td:nth-child(12) {
    background-color: #E8E8E8 !important;
  }

  #kpiTeacher td:nth-child(13) {
    background-color: #E8E8E8 !important;
  }

  #kpiTeacher td:nth-child(14) {
    background-color: #E8E8E8 !important;
  }

</style>
